module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-forgot-page no-top-nav no-side-space"
  }, [_c('v-container', {
    attrs: {
      "grid-list-item": "",
      "allChildrenCenter": "",
      "auth-card": "",
      "px-0": ""
    }
  }, [(!_vm.resetSuccess) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-center": ""
    }
  }, [(!_vm.onMobile) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "auth-card-child": "",
      "left-card": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "width": "40%",
      "src": "/static/images/nav_logo_primary.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('h3', [_vm._v("Forgot password")])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "forgot-quest"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/forgot-quest.svg",
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg4": "",
      "auth-card-child": "",
      "allChildrenCenter": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "pt-0": "",
      "flex-none": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h2', [_vm._v("Forgot password")])]), _vm._v(" "), _c('forgot-password-input')], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.resetSuccess) ? _c('div', {
    staticClass: "reset-successful-layout"
  }, [_c('h2', [_vm._v("Check your email")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "_content"
  }, [_c('img', {
    attrs: {
      "width": "40",
      "src": require('@/assets/send_airplane.svg'),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "_message"
  }, [_vm._v("\n          Instructions to reset your password were sent to\n          "), _c('strong', [_vm._v(_vm._s(this.email))])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "to-login-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "height": "40"
    },
    on: {
      "click": function($event) {
        _vm.toLogin()
      }
    }
  }, [_vm._v("\n        Login\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b08f450a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/forgot_password.vue
// module id = 1837
// module chunks = 180